import { render, staticRenderFns } from "./ReserveDetailCard.vue?vue&type=template&id=6b21b776&scoped=true"
import script from "./ReserveDetailCard.vue?vue&type=script&lang=js"
export * from "./ReserveDetailCard.vue?vue&type=script&lang=js"
import style0 from "./ReserveDetailCard.vue?vue&type=style&index=0&id=6b21b776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b21b776",
  null
  
)

export default component.exports